import { useCallback } from "react";
import { makeVar, ReactiveVar, useReactiveVar } from "@apollo/client";
import { Properties } from "graphql/generated/graphql";

export interface SelectedPropertyLocalFieldsType {
  selectedPropertyId: string;
}

const selectedPropertyInitialValue: any = {};

type SelectedPropertyType = SelectedPropertyLocalFieldsType & Properties;

// The return value of makeVar is a function that you call to read or modify your reactive variable's value.
export const selectedPropertyVar: ReactiveVar<SelectedPropertyType> =
  makeVar<SelectedPropertyType>(selectedPropertyInitialValue);

export const clearSelectedProperty = () => {
  selectedPropertyVar(selectedPropertyInitialValue);
};

export const useSelectedProperty = () => {
  const selectedPropertyValue = useReactiveVar(selectedPropertyVar);

  const updateSelectedProperty = useCallback(
    (data) => {
      selectedPropertyVar({
        ...selectedPropertyValue,
        ...data,
      });
    },
    [selectedPropertyValue]
  );

  return {
    selectedPropertyValue,
    updateSelectedProperty,
  };
};
